const mapCarrierService = carrierService => ({
  id: carrierService.id,
  name: carrierService.name,
  service_name: carrierService.service_name,
  is_reveni_contract: carrierService.is_reveni_contract,
  is_pickup_point: carrierService.is_pickup_point,
  is_connected: carrierService.is_connected,
  logo_url: carrierService.logo_url,
  supports_modification: carrierService.supports_modification,
  supports_time_ranges: carrierService.supports_time_ranges,
  source_region_ids: carrierService.source_region_ids,
  destination_region_ids: carrierService.destination_region_ids,
  restricts_exchange_address: carrierService.restricts_exchange_address,
})

export const transformResponseCarrierServices = carrierServices => carrierServices.map(mapCarrierService)
